import CmDeliveryNoteNumber from './CmDeliveryNoteNumber.vue';
import Created from './Created';
import CreatorUser from './CreatorUser';
import Currency from './Currency';
import Customer from './Customer';
import CustomerAddress from './CustomerAddress';
import CustomerCity from './CustomerCity';
import CustomerCountry from './CustomerCountry';
import CustomerCounty from './CustomerCounty';
import CustomerZip from './CustomerZip';
import DeliveryDate from './DeliveryDate';
import GrossPrice from './GrossPrice';
import Id from './Id';
import NetPrice from './NetPrice';
import ReceiptNumber from './ReceiptNumber';
import RepresentativeOrder from './RepresentativeOrder';
import Status from './Status';
import Storage from './Storage';
import Stowage from './Stowage';
import Supplier from './Supplier';
import Updated from './Updated';

export const compareTypes = {
  net_price: 'number',
  gross_price: 'number',
};

export const labels = {
  Id: 'Id',
  ReceiptNumber: 'Bizonylatszám',
  CmDeliveryNoteNumber: 'CM szlev szám',
  Status: 'Státusz',
  Supplier: 'Eladó',
  Storage: 'Raktár',
  CreatorUser: 'Rögzítette',
  NetPrice: 'Nettó ár',
  GrossPrice: 'Bruttó ár',
  Currency: 'Deviza',
  Customer: 'Vevő',
  CustomerAddress: 'Cím',
  CustomerCity: 'Város',
  CustomerCountry: 'Ország',
  CustomerCounty: 'Megye',
  RepresentativeOrder: 'Raktárközi megrendelés',
  CustomerZip: 'Irányítószám',
  DeliveryDate: 'Szállítás dátuma',
  Stowage: 'Rakodási lista',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
};
CmDeliveryNoteNumber
export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
}, {
  value: 'CmDeliveryNoteNumber',
}, {
  value: 'Supplier',
}, {
  value: 'Storage',
}, {
  value: 'CreatorUser',
}, {
  value: 'NetPrice',
}, {
  value: 'GrossPrice',
}, {
  value: 'Updated',
}, {
  value: 'Created',
}, {
  value: 'Status',
}, {
  value: 'Currency',
}, {
  value: 'CustomerAddress',
}, {
  value: 'Customer',
}, {
  value: 'CustomerCity',
}, {
  value: 'CustomerCountry',
}, {
  value: 'CustomerCounty',
}, {
  value: 'RepresentativeOrder',
}, {
  value: 'CustomerZip',
}, {
  value: 'DeliveryDate',
}, {
  value: 'Stowage',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
}, {
  value: 'CmDeliveryNoteNumber',
}, {
  value: 'Status',
}, {
  value: 'Supplier',
}, {
  value: 'Storage',
}, {
  value: 'CreatorUser',
}, {
  value: 'Customer',
}, {
  value: 'NetPrice',
}, {
  value: 'Created',
}];

export const defaultSort = {
  prop: Created.propName,
  order: 'ascending'
};

export default {
  Id,
  ReceiptNumber,
  CmDeliveryNoteNumber,
  Status,
  Supplier,
  Storage,
  CreatorUser,
  NetPrice,
  GrossPrice,
  Currency,
  Customer,
  CustomerAddress,
  CustomerCity,
  CustomerCountry,
  CustomerCounty,
  RepresentativeOrder,
  CustomerZip,
  DeliveryDate,
  Stowage,
  Created,
  Updated,
};
